import React from 'react';
import styles from './style.module.scss';
import { getImagePath } from '../../getImagePath';
import { Link } from 'react-router-dom';

const WORDING = {
    title: "0918池上地震-花東地區地震認知與避難行為調查(2023)",
    // description:
    //     "Household Survey of 0918 Earthquake Disaster: Preparedness and Response in Hualien and Taitung(2023)",
    description: "",
    cards: [
        {
            title: "主題圖表",
            subtitle: "依主題顯示0918池上地震調查結果",
            link: "/statistics/ChishangEarthquake/chart-data",
            cover: getImagePath("/homepage/card-1.jpg"),
        },
        {
            title: "客製化圖表",
            subtitle: "可自選調查問題製作統計圖表",
            link: "/statistics/ChishangEarthquake/custom-data-tutorial",
            cover: getImagePath("/homepage/card-2.jpg"),
        },
    ],
};

function HeroSection() {
    return (
        <div className={styles.heroSection}>
            <div className={styles.heroSectionText}>
                <h1
                    dangerouslySetInnerHTML={{
                        __html: WORDING.title,
                    }}
                />               
                <span />
            </div>
            <div className={styles.heroSectionCards}>
                {WORDING.cards.map((card) => (
                    <Link
                        className={styles.heroSectionCard}
                        key={card.title}
                        to={card.link}
                    >
                        <img src={card.cover} alt={card.title} />
                        <div className={styles.cardContent}>
                            <div>
                                <h2>{card.title}</h2>
                                <p>{card.subtitle}</p>
                            </div>
                            <svg
                                width="126"
                                height="126"
                                viewBox="0 0 126 126"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="1"
                                    y="1"
                                    width="124"
                                    height="124"
                                    rx="62"
                                    stroke="white"
                                    strokeWidth="2"
                                />
                                <path
                                    d="M79.1417 48.8578C79.1417 47.7532 78.2463 46.8578 77.1417 46.8578L59.1417 46.8578C58.0371 46.8578 57.1417 47.7533 57.1417 48.8578C57.1417 49.9624 58.0371 50.8578 59.1417 50.8578L75.1417 50.8578L75.1417 66.8578C75.1417 67.9624 76.0371 68.8578 77.1417 68.8578C78.2463 68.8578 79.1417 67.9624 79.1417 66.8578L79.1417 48.8578ZM50.2716 78.5563L78.5559 50.272L75.7275 47.4436L47.4432 75.7279L50.2716 78.5563Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <div className={styles.cardHoverMask}>
                            <div>
                                <div className={styles.cardHoverMaskContent}>
                                    <h2>{card.title}</h2>
                                    <p>{card.subtitle}</p>
                                </div>
                                <svg
                                    width="126"
                                    height="126"
                                    viewBox="0 0 126 126"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="1"
                                        y="1"
                                        width="124"
                                        height="124"
                                        rx="62"
                                        stroke="white"
                                        strokeWidth="2"
                                    />
                                    <path
                                        d="M79.1417 48.8578C79.1417 47.7532 78.2463 46.8578 77.1417 46.8578L59.1417 46.8578C58.0371 46.8578 57.1417 47.7533 57.1417 48.8578C57.1417 49.9624 58.0371 50.8578 59.1417 50.8578L75.1417 50.8578L75.1417 66.8578C75.1417 67.9624 76.0371 68.8578 77.1417 68.8578C78.2463 68.8578 79.1417 67.9624 79.1417 66.8578L79.1417 48.8578ZM50.2716 78.5563L78.5559 50.272L75.7275 47.4436L47.4432 75.7279L50.2716 78.5563Z"
                                        fill="white"
                                    />
                                </svg>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default HeroSection;
